export default {"src":"/_next/static/media/opencv.96c1a6d0.svg","height":238,"width":256,"blurWidth":0,"blurHeight":0};